import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import style from './ChangeLogModal.module.sass';

const ChangeLogModal = ({ onClose }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLog = async () => {
    try {
      const response = await axios.get('/api/v1/calendar_jobs/change_log');
      setEntries(response.data.entries || []);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch change log:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLog();
  }, []);

  const renderEntries = () => {
    if (loading) {
      return <div className={style.loading}>Loading...</div>;
    }
    if (entries.length === 0) {
      return <div className={style.empty}>No log entries yet</div>;
    }
    return (
      <div className={style.logEntries}>
        {entries.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className={style.logEntry}>
            {entry}
          </div>
        ))}
      </div>
    );
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={style.overlay} onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div className={style.modal} onClick={(e) => e.stopPropagation()}>
        <div className={style.header}>
          <h2>Change Log</h2>
          <button type="button" className={style.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={style.content}>
          {renderEntries()}
        </div>
        <div className={style.footer}>
          <button type="button" className={style.refreshButton} onClick={fetchLog}>
            Refresh
          </button>
          <button type="button" className={style.closeModalButton} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

ChangeLogModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ChangeLogModal;
